const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'development';

export const defaultStoryblokStoryParams = {
  version: activeEnv === 'production' ? 'published' : 'draft',
};

export const defaultStoryblokStoriesParams = {
  version: activeEnv === 'production' ? 'published' : 'draft',
};

export const defaultStoryblokParams = {
  version: activeEnv === 'production' ? 'published' : 'draft',
};

export const defaultStoryblokBridgeConfig = {};
